export function throwInternError(error){
    //TODO Sentry implementation
    console.log(error);
}